"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPinColorForMap = void 0;
var theme_1 = require("../../theme");
var inventoriedMarker = require('../../../assets/Pin-Inventoried.svg');
var scheduledMarker = require('../../../assets/Pin-Scheduled.svg');
var inProgressMarker = require('../../../assets/Pin-InProgress.svg');
var completedMarker = require('../../../assets/Pin-Completed.svg');
var errorMarker = require('../../../assets/Pin-Error.svg');
var warningMarker = require('../../../assets/Pin-Warning.svg');
var getPinColorForMap = function (color) {
    var markerImage = inventoriedMarker;
    if (color === theme_1.colors.black) {
        markerImage = inventoriedMarker;
    }
    if (color === theme_1.colors.primary) {
        markerImage = scheduledMarker;
    }
    if (color === theme_1.colors.purple) {
        markerImage = inProgressMarker;
    }
    if (color === theme_1.colors.success) {
        markerImage = completedMarker;
    }
    if (color === theme_1.colors.error) {
        markerImage = errorMarker;
    }
    if (color === theme_1.colors.warning) {
        markerImage = warningMarker;
    }
    return markerImage;
};
exports.getPinColorForMap = getPinColorForMap;
//# sourceMappingURL=EnvirioMarker.js.map